import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/FileArrowUp.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: i }));
r.displayName = "FileArrowUpIcon";
const c = r;
export {
  c as FileArrowUp,
  r as FileArrowUpIcon
};
